import * as moment from 'moment';

import { Amendment } from '@app/domain/model/amendment';
import { Purchase } from '@app/domain/model/purchase';
import { ReportType } from '@app/domain/model/report-type';
import { Vessel } from '@app/domain/model/vessel';
import { ApprovalStatus } from '@app/domain/model/approval-status';

/**
 * Purchase report.
 *
 * @author Warlock, AIS.PL
 */
export class PurchaseReport {

  readonly amendments: Amendment[];

  readonly boatNotUsed: boolean;

  readonly notifyFisher: boolean;

  readonly purchases: Purchase[];

  readonly reportDate: Date;

  readonly reportType: ReportType;

  readonly remarks: string;

  readonly sellerId: number;

  readonly submittedBy: string;

  readonly submittedOn: Date;

  readonly vessel: Vessel;

  readonly deleted: boolean;

  readonly status: ApprovalStatus;

  /**
   * Converts JSON representation of reporting period into {@link PurchaseReport} instance.
   *
   * @param jsonObject JSON representation of purchase report
   */
  static fromJSON(jsonObject: any): PurchaseReport {
    const result = Object.create(PurchaseReport.prototype);
    return Object.assign(result, jsonObject, {
      amendments: jsonObject.amendments ? (jsonObject.amendments as any[]).map(element => Amendment.fromJSON(element)) : null,
      purchases: jsonObject.purchases ? (jsonObject.purchases as any[]).map(element => Purchase.fromJSON(element)) : null,
      reportDate: jsonObject.reportDate ? moment(jsonObject.reportDate).toDate() : null,
      reportType: jsonObject.reportType ? ReportType.fromString(jsonObject.reportType) : null,
      sellerId: jsonObject.sellerId ? Number(jsonObject.sellerId) : null,
      status: jsonObject.status ? ApprovalStatus.fromString(jsonObject.status) : null
    });
  }

}



